/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Button, Card, CardContent, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import { GridSearchIcon } from "@mui/x-data-grid";
import axios from "axios";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import DeleteModal from "components/deletemodal/deletemodal";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useCallback, useEffect, useMemo, useState } from "react";
import { createTheme } from "react-data-table-component";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { deleteItems, fetchItems } from "utils/api";
import { appConstants } from "utils/appConstants";
import { generateDataList, getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import LoadingModal from "../../components/LoadingModel/loadingModal";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconMenu from "components/CustomMaterialMenu/Custom";


let searchParameter = "";
let itemStatus = "Active";
let categoryName = "All";
let categoryCodeName = "All";
const SCREEN_NAME = "Items";
let SCREEN_RIGHT;

createTheme(
  'solarized',
  {
    text: {
      primary: 'white',
      secondary: 'white',
    },
    background: {
      default: '#202940',
    },
    context: {
      background: '#202940',
      text: 'white',
    },
    divider: {
      default: 'white',
    },
    sortFocus: {
      default: '#2aa198',
    },
  },
  'dark',
);
createTheme(
  'light',
  {
    text: {
      primary: 'black',
      secondary: 'black',
    },
    background: {
      default: 'white',
    },
    context: {
      background: 'white',
      text: 'black',
    },
    divider: {
      default: 'gray',
    },
    sortFocus: {
      default: '#2aa198',
    },
  },
  'dark',
);

function ItemCategory() {
  //Starts here change the pagination text Rows per page to Record per page
  let changePaginationText = document.getElementsByClassName("rdt_Pagination")[0];
  if (changePaginationText !== undefined) {
    changePaginationText.getElementsByTagName('span')[0].textContent = "Records Per Page";
  }
  //ends here change the pagination text Rows per page to Record per page
  const [loading, setLoading] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [deleteHeading, setDeleteHeading] = useState("");
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [title, setTitle] = useState("");
  const [controller] = useMaterialUIController();
  const dispatch = useDispatch();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [screenAccess, setScreenAccess] = useState(false);
  // const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
  const [values, setValues] = useState({
    _id: '',
    sortingType: "",
    sortingField: "",
    itemStatus: "All",
    categoryName: "All",
    categoryCodeName: "All",
    durationDate: "",
    fromDate: "",
    toDate: "",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    searchParameterList: ['categoryName', 'itemName', 'itemCode', 'unitOfMeasurement', 'itemStatus', 'categoryCodeName'],
    businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.businessUserID,
  });

  const [itemCategoriesName, setItemCategoriesName] = useState([]);

  useEffect(() => {
    (async () => {
      let duration = new URLSearchParams(window.location.search).get('duration');
      let customFrom = new URLSearchParams(window.location.search).get('from');
      let customTo = new URLSearchParams(window.location.search).get('to');
      duration && (values.durationDate = duration)
      customFrom && (values.fromDate = customFrom)
      customTo && (values.toDate = customTo)
      await getRight();
      await fetchCategories();
      await fetchItem();
    })();

  }, [values.categoryName, values.categoryCodeName, values.itemStatus, values.sortingType, perPage, dispatch]);

  async function getRight() {
    let right = await getScreenRight("Items")
    console.log("right", right)
    if (right === "Full Access") {
      setDisableColor(false)
      setScreenAccess(true)
    } else {
      setDisableColor(true)
    }
  }
  const handleCancel = (name) => (event) => {
    setSelectedRows([]);
    setDeleteDialogeFlag(false);
  };

  const handleDeleteDialogeClick = async (_id) => {

    values._id = _id;
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleDelete = async (id) => {
    deleteItem();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = page => {
    values.page = page;
    fetchItem();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setToggleCleared(!toggleCleared);
    setSelectedRows([]);
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };

  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };

  const contextActions = useMemo(() => {
    const handleDeleteMultiple = () => {
      if (toggleCleared) { setSelectedRows([]); }

      setDeleteDialogeFlag(!deleteDialogeFlag);
      setDeleteHeading("Would you like to delete selected records? ");
      if (selectedRows) {
        values.selectedRows = selectedRows;
      }
    };
    return (
      <Grid container gap={3} display={"flex"}>
        {screenAccess ? (
          <MDButton onClick={handleDeleteMultiple} color="error">
            Delete
          </MDButton>
        ) : null}
      </Grid>
    );
  }, [selectedRows, toggleCleared]);

  let fetchCategories = async () => {
    await axios
      .post(appConstants.baseURL + "items/fetchCategoriesData", { businessUserID: values.businessUserID })
      .then(
        async (res) => {
          let response = res.data.fetchCategories;
          console.log("mresponse", response)
          response.length > 0 && setItemCategoriesName(await generateDataList(response, "categoryCodeName", "categoryCodeName"));
        }
      )
      .catch(
        (error) => {
          console.log("Error in Fetching" + JSON.stringify(error))
          setLoading(false);
        }
      )
  }

  // const handleRowSelected = useCallback(state => {
  //   setSelectedRows(state.selectedRows);
  //   if (state.selectedRows.length > 0) {
  //     setTitle(" ");
  //   }
  //   else {
  //     setTitle("");
  //     setDeleteHeading("");
  //   }
  // }, []);

  const handleRowSelected = useCallback(state => {
    let data = state.selectedRows
    if (data.length > 0) {
      setSelectedRows(
        data.map((a) =>
          a._id
        ))
      setTitle(" ")

    }
    else {
      setTitle("");
      setDeleteHeading("");
    }
  }, []);

  const deleteItem = async () => {
    await deleteItems(values, (data) => {
      setValues({ ...values, _id: [] });
      fetchItem();
      setToggleCleared(true);
      setTitle("");
      showResMsg(data.Result_Status ? genericMessage.deleted : data.Result_Message, 1000, data.Result_Status);
    }, dispatch)
  };

  const fetchItem = async () => {
    await fetchItems(values, (data) => {
      setTotalRows(data.Result_Output.totalDocs);
      setRows(data.Result_Output.docs)
    }, dispatch)
  };

  useEffect(() => {
    itemStatus = values.itemStatus;
    categoryName = values.categoryName;
    categoryCodeName = values.categoryCodeName;
  }, [values.itemStatus, values.categoryName, values.categoryCodeName]);


  const customStyles = {
    table: {
      style: {
        borderColor: tableBorder,
      },
    },
    headRow: {
      style: {
        color: darkMode ? "white" : "white",
        background: barColor,
      },
    },
    headCells: {
      style: {
        // paddingLeft: '10px',
        // paddingRight: '10px',
        fontWeight: 'bold',
        fontSize: '14px',
        color: "white",

      },
    },
  };

  let columns = [

    {
      // name: "Item Name",
      name: <p style={{ paddingLeft: "20px", fontSize: "12px" }}>Item Name</p>,
      // selector: row => row.itemName,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.itemName}</span>
      ),
      sortable: true,
      sortField: 'itemName',
      style: { paddingLeft: "10px" },
      center: true,

    },

    {
      // name: "Item Code",
      name: <p style={{ paddingLeft: "20px", fontSize: "12px" }}>Item Code</p>,
      // selector: row => row.itemCode,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.itemCode}</span>
      ),
      sortable: true,
      sortField: 'itemCode',
      center: true,
    },

    {
      // name: "Status",
      name: <p style={{ paddingLeft: "15px", fontSize: "12px" }}>Status</p>,
      // selector: row => row.itemStatus,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.itemStatus}</span>
      ),
      sortable: true,
      sortField: 'itemStatus',
      center: true,
      cell: row => (
        <span
          style={{
            border: "1px solid black",
            color: "black",
            padding: "3px 3px",
            borderRadius: "2px",
            fontSize: "12px",
            fontWeight: 500,
            textTransform: "capitalize",
            display: "inline-block",
            minWidth: "60px",
            textAlign: "center",
          }}
        >
          {row.itemStatus || "N/A"}
        </span>
      )
    },

    {
      // name: "Item Category Name",
      name: <p style={{ fontSize: "12px" }}>Account Name</p>,
      // selector: row => row.categoryName,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.categoryCodeName}</span>
      ),
      sortable: true,
      sortField: 'categoryCodeName',

    },


    // {
    //   // name: "Unit of Measurement",
    //   name: <p style={{ paddingLeft: "20px", fontSize: "12px", textAlign: "center" }}>Unit of Measurement</p>,
    //   // selector: row => row.unitOfMeasurement,
    //   selector: row => (
    //     <span style={{ fontSize: "12px", textAlign: "center" }}>{row.unitOfMeasurement}</span>
    //   ),
    //   sortable: true,
    //   sortField: 'unitOfMeasurement',
    //   center: true,
    // },

    {
      // name: "Action(s)",
      name: <p style={{ fontSize: "12px" }}>Action(s)</p>,
      // selector: row => row._id,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row._id}</span>
      ),
      center: true,
      cell: row => <IconMenu size="small" row={
        <>
          {/* <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}> */}
          <Grid style={{ width: "100%" }} item>


            <Link
              to={`/items/editItem/${row._id}`} disabled={!screenAccess}
            >
              <p style={darkMode ? { color: "white" } : { color: "black" }}>
                <TimelineItem color="success"
                  // icon="edit" 
                  icon={<EditIcon className="actionicon" />}
                  title="Edit" />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</p>
            </Link>
          </Grid>
          <Grid style={{ width: "100%" }} item >
            <p style={darkMode ? { color: "white" } : { color: "black" }} onClick={() => handleDeleteDialogeClick(row._id)} disabled={!screenAccess}>
              <TimelineItem
                color="error"
                // icon="delete"
                icon={<DeleteIcon className="actionicon" />}
                onClick={() => handleDeleteDialogeClick(row._id)}
                title="Delete"
              />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete</p>
          </Grid>
          {/* </Grid> */}
        </>
      } />,
    },
  ];


  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 350,
        overflowY: 'scroll',
      },
    },
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName="Items" />
          <Grid container display={"flex"} justifyContent="end" mt={2.2} gap={2} >
            <Grid lg={2.5} xs={6} >
              <FormControl fullWidth>
                <InputLabel id="Categories">Filter By Account</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "38.11px" }}
                  label="Filter By Category"
                  value={values.categoryCodeName}
                  onChange={(e) => setValues({ ...values, categoryCodeName: e.target.value })}
                  MenuProps={MenuProps}
                >
                  <MenuItem value="All">All</MenuItem>
                  {itemCategoriesName}
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6} >
              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "38.11px" }}
                  label="Filter By Status"
                  value={values.itemStatus}
                  onChange={(e) => setValues({ ...values, itemStatus: e.target.value })}

                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6}>
              <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") fetchItem();
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment  >
                      <Button style={{ borderRadius: "0px 0.3rem  0.3rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchItem}>
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <div style={{ marginRight: '16px' }}>
              {/* <Link to={"/addItems"}>
                <MDButton
                  variant="contained"
                  color="success"
                  style={{ height: "38.11px" }}
                >
                  Add New
                </MDButton>
              </Link> */}
              {screenAccess ?
                <Link to={"/items/addItems"}>
                  <MDButton
                    variant="contained"
                    color="success"
                    style={{ height: "38.11px" }}
                  >
                    Add New
                  </MDButton>
                </Link>
                :
                <MDButton
                  variant="contained"
                  className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                  color="secondary"
                  style={{ height: "38.11px" }}
                >
                  Add New
                </MDButton>
              }
            </div>
          </Grid>
          {/* <CardContent> */}
          <BTable
            theme={darkMode ? 'solarized' : 'light'}
            title={title}
            columns={columns}
            data={rows}
            selectable
            selectableRows={screenAccess ? true : false}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            customStyles={customStyles}
            contextActions={contextActions}
            onSelectedRowsChange={handleRowSelected}
            clearSelectedRows={toggleCleared}
            fixedHeaderScrollHeight="410px"
            fixedHeader={true}
          />
          {/* </CardContent> */}
        </Card>
      </div >
      <DeleteModal
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
        message={deleteHeading}
      />
      <LoadingModal loading={loading} />

    </DashboardLayout>
  );

}

export default ItemCategory;
